// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2017, 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

/*-----------------------------------------------------------------------------
| Variables
|----------------------------------------------------------------------------*/

:root {
  --theia-private-menubar-height: 32px;
  --theia-private-menu-item-height: 24px;
  --theia-menu-z-index: 10000;
}

/*-----------------------------------------------------------------------------
| MenuBar
|----------------------------------------------------------------------------*/

.p-Widget.p-MenuBar {
  display: flex;
  align-items: center; 
  padding-left: 5px;
  font-size: var(--theia-ui-font-size1);
}

.p-MenuBar-menu {
  transform: translateY(calc(-2 * var(--theia-border-width)));
}

.p-MenuBar-content {
  display: flex;
  align-items: center; 
}

.p-MenuBar-item {
  padding: 0px 8px;
  line-height: var(--theia-content-line-height);
  border-radius: 4px;
}

.p-MenuBar-item .p-MenuBar-itemLabel {
  white-space: pre;
}

.p-MenuBar-item.p-mod-active {
  background: var(--theia-menubar-selectionBackground);
  color: var(--theia-menubar-selectionForeground);
  opacity: 1;
}

.p-MenuBar.p-mod-active .p-MenuBar-item.p-mod-active {
  z-index: calc(var(--theia-menu-z-index) - 1);
  background: var(--theia-menubar-selectionBackground);
  border-left: var(--theia-border-width) solid
    var(--theia-menubar-selectionBorder);
  border-right: var(--theia-border-width) solid
    var(--theia-menubar-selectionBorder);
}

.p-MenuBar-item.p-mod-disabled {
  opacity: var(--theia-mod-disabled-opacity);
}

.p-MenuBar-item.p-type-separator {
  margin: 2px;
  padding: 0;
  border: none;
  border-left: var(--theia-border-width) solid
    var(--theia-menu-separatorBackground);
}

.p-MenuBar-itemMnemonic {
  text-decoration: underline;
}

#theia-top-panel {
  background: var(--theia-titleBar-activeBackground);
  color: var(--theia-titleBar-activeForeground);
  display: flex;
  min-height: var(--theia-private-menubar-height);
  border-bottom: 1px solid var(--theia-titleBar-border);
}
#theia-top-panel:window-inactive,
#theia-top-panel:-moz-window-inactive {
  background: var(--theia-titleBar-inactiveBackground);
  color: var(--theia-titleBar-inactiveForeground);
}

/*-----------------------------------------------------------------------------
| Menu
|----------------------------------------------------------------------------*/

.p-Menu {
  z-index: var(--theia-menu-z-index);
  padding: 4px;
  background: var(--theia-menu-background);
  color: var(--theia-menu-foreground);
  font-size: var(--theia-ui-font-size1);
  box-shadow: 0px 1px 6px var(--theia-widget-shadow);
  border: 1px solid var(--theia-menu-border);
  border-radius: 5px;
}

.p-Menu:focus {
  outline: none;
}

.p-Menu-item {
  min-height: var(--theia-private-menu-item-height);
  max-height: var(--theia-private-menu-item-height);
  padding: 0px;
  /** 
   * FireFox adds 0.5px to all menu items for some reason
   * Subtracting that amount fixes the behavior on FireFox and doesn't introduce issues on Chromium
   */
  line-height: calc(var(--theia-private-menu-item-height) - 0.5px);
  overflow: hidden;
}

.p-Menu-item.p-mod-active {
  color: var(--theia-menu-selectionForeground);
  border: thin solid var(--theia-menu-selectionBorder);
  opacity: 1;
  cursor: pointer;
}

/** 
 * We cannot apply border-radius on items with \`display: table-row\` 
 * So we apply it to its first and last child
 */

.p-Menu-item.p-mod-active > div {
  background: var(--theia-menu-selectionBackground);
}

.p-Menu-item.p-mod-active > div:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.p-Menu-item.p-mod-active > div:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.p-Menu-item.p-mod-disabled {
  opacity: var(--theia-mod-disabled-opacity);
}

.p-Menu-itemIcon {
  width: 21px;
  padding: 0px 2px 0px 4px;
  height: var(--theia-private-menu-item-height);
}

.p-Menu-itemLabel {
  padding: 0px 32px 0px 2px;
}

.p-Menu-itemMnemonic {
  text-decoration: underline;
}

.p-Menu-itemShortcut {
  padding: 0px;
}

.p-Menu-itemSubmenuIcon {
  width: var(--theia-icon-size);
  padding: 0px 10px 0px 0px;
}

.p-Menu-item[data-type="separator"] > div {
  padding: 0;
  height: 9px;
  opacity: 0.36;
}

.p-Menu-item[data-type="separator"] > div::after {
  content: "";
  display: block;
  position: relative;
  top: 4px;
  border-top: var(--theia-border-width) solid
    var(--theia-menu-separatorBackground);
}

.p-Menu-item[data-type="separator"] > div:first-child:after {
  margin-left: -4px;
}

.p-Menu-item[data-type="separator"] > div:last-child::after {
  margin-right: -4px;
}

.p-Menu-itemIcon::before,
.p-Menu-itemSubmenuIcon::before {
  font: normal normal normal 16px/1 codicon;
  display: inline-block;
  text-decoration: none;
  text-rendering: auto;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  transform: translateY(20%);
}

.p-Menu-item.p-mod-toggled > .p-Menu-itemIcon::before {
  content: "\\eab2";
  transform: scale(0.8) translateY(20%);
}

.p-Menu-item[data-type="submenu"] > .p-Menu-itemSubmenuIcon::before {
  content: "\\eab6";
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@theia/core/src/browser/style/menus.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;;8EAE8E;;AAE9E;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;;8EAE8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,4CAA4C;EAC5C,oDAAoD;EACpD;wCACsC;EACtC;wCACsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ;yCACuC;AACzC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kDAAkD;EAClD,6CAA6C;EAC7C,aAAa;EACb,+CAA+C;EAC/C,qDAAqD;AACvD;AACA;;EAEE,oDAAoD;EACpD,+CAA+C;AACjD;;AAEA;;8EAE8E;;AAE9E;EACE,kCAAkC;EAClC,YAAY;EACZ,wCAAwC;EACxC,mCAAmC;EACnC,qCAAqC;EACrC,kDAAkD;EAClD,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iDAAiD;EACjD,iDAAiD;EACjD,YAAY;EACZ;;;IAGE;EACF,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,oDAAoD;EACpD,UAAU;EACV,eAAe;AACjB;;AAEA;;;EAGE;;AAEF;EACE,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR;yCACuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yCAAyC;EACzC,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2017, 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n/*-----------------------------------------------------------------------------\n| Variables\n|----------------------------------------------------------------------------*/\n\n:root {\n  --theia-private-menubar-height: 32px;\n  --theia-private-menu-item-height: 24px;\n  --theia-menu-z-index: 10000;\n}\n\n/*-----------------------------------------------------------------------------\n| MenuBar\n|----------------------------------------------------------------------------*/\n\n.p-Widget.p-MenuBar {\n  display: flex;\n  align-items: center; \n  padding-left: 5px;\n  font-size: var(--theia-ui-font-size1);\n}\n\n.p-MenuBar-menu {\n  transform: translateY(calc(-2 * var(--theia-border-width)));\n}\n\n.p-MenuBar-content {\n  display: flex;\n  align-items: center; \n}\n\n.p-MenuBar-item {\n  padding: 0px 8px;\n  line-height: var(--theia-content-line-height);\n  border-radius: 4px;\n}\n\n.p-MenuBar-item .p-MenuBar-itemLabel {\n  white-space: pre;\n}\n\n.p-MenuBar-item.p-mod-active {\n  background: var(--theia-menubar-selectionBackground);\n  color: var(--theia-menubar-selectionForeground);\n  opacity: 1;\n}\n\n.p-MenuBar.p-mod-active .p-MenuBar-item.p-mod-active {\n  z-index: calc(var(--theia-menu-z-index) - 1);\n  background: var(--theia-menubar-selectionBackground);\n  border-left: var(--theia-border-width) solid\n    var(--theia-menubar-selectionBorder);\n  border-right: var(--theia-border-width) solid\n    var(--theia-menubar-selectionBorder);\n}\n\n.p-MenuBar-item.p-mod-disabled {\n  opacity: var(--theia-mod-disabled-opacity);\n}\n\n.p-MenuBar-item.p-type-separator {\n  margin: 2px;\n  padding: 0;\n  border: none;\n  border-left: var(--theia-border-width) solid\n    var(--theia-menu-separatorBackground);\n}\n\n.p-MenuBar-itemMnemonic {\n  text-decoration: underline;\n}\n\n#theia-top-panel {\n  background: var(--theia-titleBar-activeBackground);\n  color: var(--theia-titleBar-activeForeground);\n  display: flex;\n  min-height: var(--theia-private-menubar-height);\n  border-bottom: 1px solid var(--theia-titleBar-border);\n}\n#theia-top-panel:window-inactive,\n#theia-top-panel:-moz-window-inactive {\n  background: var(--theia-titleBar-inactiveBackground);\n  color: var(--theia-titleBar-inactiveForeground);\n}\n\n/*-----------------------------------------------------------------------------\n| Menu\n|----------------------------------------------------------------------------*/\n\n.p-Menu {\n  z-index: var(--theia-menu-z-index);\n  padding: 4px;\n  background: var(--theia-menu-background);\n  color: var(--theia-menu-foreground);\n  font-size: var(--theia-ui-font-size1);\n  box-shadow: 0px 1px 6px var(--theia-widget-shadow);\n  border: 1px solid var(--theia-menu-border);\n  border-radius: 5px;\n}\n\n.p-Menu:focus {\n  outline: none;\n}\n\n.p-Menu-item {\n  min-height: var(--theia-private-menu-item-height);\n  max-height: var(--theia-private-menu-item-height);\n  padding: 0px;\n  /** \n   * FireFox adds 0.5px to all menu items for some reason\n   * Subtracting that amount fixes the behavior on FireFox and doesn't introduce issues on Chromium\n   */\n  line-height: calc(var(--theia-private-menu-item-height) - 0.5px);\n  overflow: hidden;\n}\n\n.p-Menu-item.p-mod-active {\n  color: var(--theia-menu-selectionForeground);\n  border: thin solid var(--theia-menu-selectionBorder);\n  opacity: 1;\n  cursor: pointer;\n}\n\n/** \n * We cannot apply border-radius on items with `display: table-row` \n * So we apply it to its first and last child\n */\n\n.p-Menu-item.p-mod-active > div {\n  background: var(--theia-menu-selectionBackground);\n}\n\n.p-Menu-item.p-mod-active > div:first-child {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.p-Menu-item.p-mod-active > div:last-child {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.p-Menu-item.p-mod-disabled {\n  opacity: var(--theia-mod-disabled-opacity);\n}\n\n.p-Menu-itemIcon {\n  width: 21px;\n  padding: 0px 2px 0px 4px;\n  height: var(--theia-private-menu-item-height);\n}\n\n.p-Menu-itemLabel {\n  padding: 0px 32px 0px 2px;\n}\n\n.p-Menu-itemMnemonic {\n  text-decoration: underline;\n}\n\n.p-Menu-itemShortcut {\n  padding: 0px;\n}\n\n.p-Menu-itemSubmenuIcon {\n  width: var(--theia-icon-size);\n  padding: 0px 10px 0px 0px;\n}\n\n.p-Menu-item[data-type=\"separator\"] > div {\n  padding: 0;\n  height: 9px;\n  opacity: 0.36;\n}\n\n.p-Menu-item[data-type=\"separator\"] > div::after {\n  content: \"\";\n  display: block;\n  position: relative;\n  top: 4px;\n  border-top: var(--theia-border-width) solid\n    var(--theia-menu-separatorBackground);\n}\n\n.p-Menu-item[data-type=\"separator\"] > div:first-child:after {\n  margin-left: -4px;\n}\n\n.p-Menu-item[data-type=\"separator\"] > div:last-child::after {\n  margin-right: -4px;\n}\n\n.p-Menu-itemIcon::before,\n.p-Menu-itemSubmenuIcon::before {\n  font: normal normal normal 16px/1 codicon;\n  display: inline-block;\n  text-decoration: none;\n  text-rendering: auto;\n  text-align: center;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  transform: translateY(20%);\n}\n\n.p-Menu-item.p-mod-toggled > .p-Menu-itemIcon::before {\n  content: \"\\eab2\";\n  transform: scale(0.8) translateY(20%);\n}\n\n.p-Menu-item[data-type=\"submenu\"] > .p-Menu-itemSubmenuIcon::before {\n  content: \"\\eab6\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
